import React from 'react';
import { Condiments } from '../../../models/condiment.entity';
import { apiManage_rbp } from '../../../request';
import i18n from '../../../i18n';
import _ from 'lodash';
import MenuListComponent, { ContextMenuKey, MenuListItem } from '../menu-list/menu-list-component';
import GlobalNotification from '../../../component/common/snackbar';
import { export2Excel, firstMissingPositive, sheetDataType } from '../../../constants/utils';
import { Box, Button, Grid } from '@mui/material';
import DialogComponent from '../../../component/dialog/dialog.component';
import CommonInput from '../../../component/form/common-input.component';
import CondimentGroupDetail from './condiment-group-detail.component';
import setLoading from '../../../component/linear-determinate';
import ButtonComponent from '../../../component/button/button.component';
import DeleteDialogComponent from '../../../component/dialog/delete-dialog.component';


/**
 * 调味品组组件
 */
class CondimentGroupComponent extends React.Component<Props, State> {
    public state: State = {
        // 菜单数据
        menuData: [],
        // 删除二次确认弹窗
        deleteOpen: false,
        // 税率组列表
        taxGroup: [],
        // 加载中 初次加载时候使用
        isLoading: true,
        // 当前id最大的调味品
        lastId: 1,
        // 自定义报表主类别
        majorGroupList: [],
        // 自定义报表子类别
        familyGroupList: [],
        // 规格设置
        unitList: [],
        // 创建调味品组弹窗
        isShowCreateGroupDialog: false,
        // 创建调味品组名称
        groupName: '',
    }
    // *********************
    // Life Cycle Function
    // *********************

    constructor(props: Props) {
        super(props);
        this.updateMenuData = this.updateMenuData.bind(this)
    }
    public async componentDidMount() {
        await this.init()
    }

    // *********************
    // Default Function
    // *********************

    // 初始化
    public async init() {
        try {
            setLoading(true);
            await Promise.all([
                this.getMenuData(),
                this.getTaxGroup(),
                this.getMajorGroup(),
                this.getFamilyGroup(),
                this.getPriceSpecification(),
                this.getMenuItem(),
            ]).then((values) => {
                const menuData = values[0];
                this.setState({
                    activeMenuIndex: menuData.length > 0 ? '[0]' : '',
                    taxGroup: values[1],
                    menuData,
                    lastId: values[5].bestId,
                    majorGroupList: values[2],
                    familyGroupList: values[3],
                    unitList: values[4],
                    isLoading: false,
                })
            }).catch((error) => {
                console.log(error)
            })
            setLoading(false);
        } catch (error) {
            setLoading(false);
            this.setState({
                isLoading: false
            })
        }
    }


    /**
     * 获取税率组列表
     */
    public async getTaxGroup() {
        const result = await apiManage_rbp.get_tax_group();
        if (!_.get(result, 'error')) {
            // 税率组
            const taxGroup = result.map((item) => ({
                label: item.tax_group_name || '',
                value: item.tax_group_id || 0
            }));
            taxGroup.unshift({
                value: -1,
                label: i18n.t('menu_and_dishes_page_not_specified')
            })
            return taxGroup
        }
        return []
    }

    /**
     * 获取报表主类别
     */
    public async getMajorGroup() {
        const result = await apiManage_rbp.getDishReportLabel();
        if (!_.get(result, 'error')) {
            const group = result.map((item) => ({
                label: item.major_group_name || '',
                value: item.major_group_id || 0
            }));
            group.unshift({
                value: -1,
                label: i18n.t('menu_and_dishes_page_not_specified')
            })
            return group
        }
        return []
    }

    /**
     * 获取报表子类别
     */
    public async getFamilyGroup() {
        const result = await apiManage_rbp.getDishPostLabel();
        if (!_.get(result, 'error')) {
            const group = result.map((item) => ({
                label: item.family_group_name || '',
                value: item.family_group_id || 0
            }));
            group.unshift({
                value: -1,
                label: i18n.t('menu_and_dishes_page_not_specified')
            })
            return group
        }
        return []
    }
    /**
     * 获取规格
     */
    public async getPriceSpecification() {
        const result = await apiManage_rbp.getPriceSpecification();
        if (!_.get(result, 'error')) {
            const group = result.map((item) => ({
                label: item.unit_name || '',
                value: item.unit_name || ''
            }));
            return group
        }
        return []
    }

    /**
     * 获取调味品菜单
     */
    public async getMenuData() {
        // 获取调味品
        const condimentResult = await apiManage_rbp.get_condiments_group({
            // 是否按调味品组对调味品进行分组
            with_group: true,
        });

        if (!_.get(condimentResult, 'error')) {
            return condimentResult
        }
        return []
    }


    /**
     * 点击菜单
     * @param menuData
     * @param index
     */
    handleClick(menuData: MenuListItem, index: string) {
        this.setState({
            activeMenuIndex: ''
        }, () => {
            this.setState({
                activeMenuIndex: index
            })
        })
    }

    /**
     * 右键点击事件处理
     * @param menu
     * @param index
     * @param key
     */
    handleMenuClick(key: ContextMenuKey, menu: MenuListItem) {
        this.setState({
            activeContextMenu: menu && menu.dataSource
        })

        switch (key) {
            // 新增同级
            case 'ADD': {
                this.setState({ isShowCreateGroupDialog: true })
                return;
            }
            // 删除同级
            case 'DELETE': {
                this.handleDeleteMenu()
                return;
            }
        }
    }


    /**
     * 新增调味品组
     */
    async handleAddMenu() {
        if (!this.state.groupName.trim()) {
            GlobalNotification.error(i18n.t('staff_setting_page_enter_type_name'))
            return
        }
        // setLinearLoading(true);
        // 最后一个调味品
        const lastMenuId = _.last(this.state.menuData)?.scomdiment_groups_id;
        const params = {
            scomdiment_groups_id: Number(lastMenuId || 0) + 1,
            comdiment_groups_name: this.state.groupName
        }
        const result = await apiManage_rbp.post_condiments_group(params);
        if (!_.get(result, 'error')) {
            // 刷新数据
            const condimentResult = await this.getMenuData();
            const { bestId } = await this.getMenuItem()
            GlobalNotification.success(i18n.t('global_text_operate_success'))
            this.setState({
                menuData: condimentResult,
                lastId: bestId,
                isShowCreateGroupDialog: false,
                groupName: ''
            })

        } else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }

        // setLinearLoading(false);

    }

    /**
     * 删除菜单
     * @param menu
     * @param index
     */
    handleDeleteMenu() {
        this.setState({
            deleteOpen: true
        })
    }

    /**
     * 删除菜单
     */
    async deleteMenu() {
        const { activeContextMenu } = this.state;
        //  发起删除请求
        if (activeContextMenu && (activeContextMenu.comdiments || []).length === 0) {
            const result = await apiManage_rbp.del_condiment_group([activeContextMenu.scomdiment_groups_id as number])
            if (!_.get(result, 'error')) {
                // 刷新数据
                const condimentResult = await this.getMenuData();
                const { bestId } = await this.getMenuItem()
                this.setState({
                    menuData: condimentResult,
                    lastId: bestId
                })

                GlobalNotification.success(i18n.t('global_text_operate_success'))
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        }
        else if (activeContextMenu && (activeContextMenu.comdiments || []).length > 0) {
            GlobalNotification.warning(i18n.t('tax_group_page_current_node_have_sub_node_delete_sub_node_in_advance'))
        }

    }

    async updateMenuData(id?: number): Promise<Condiments> {
        const condimentResult = await this.getMenuData();
        const { bestId } = await this.getMenuItem();
        this.setState({
            menuData: condimentResult,
            lastId: bestId
        })
        if (typeof id !== 'undefined') {
            return condimentResult.find((item) => item.scomdiment_groups_id === id) || {}
        }
        return {}
    }

    handleExport() {
        const { menuData } = this.state
        const sheetData: sheetDataType = [{ data: [], sheetName: 'Condiments' }, { data: [], sheetName: 'Condiment_Groups' }]
        for (const menu of menuData) {
            sheetData[1].data.push({
                'ID': menu.scomdiment_groups_id,
                'Name': menu.comdiment_groups_name
            })
            for (const condiment of (menu.comdiments || [])) {
                sheetData[0].data.push({
                    'ID': condiment.item_id,
                    'Name': condiment.item_name1,
                    'Name2': condiment.item_name2,
                    'GroupName': menu.comdiment_groups_name,
                    'Price1': condiment.price_1,
                    'Unit1': condiment.unit_1
                })
            }
        }
        export2Excel(sheetData, 'Condiment')
    }

    // 批量导入调味品
    public handleUpload = async (params: any) => {
        const result = await apiManage_rbp.mul_upload_condiment(params.condimentData);
        if (!_.get(result, 'error')) {
            GlobalNotification.success(i18n.t('global_text_operate_success'))
            // 刷新数据
            const res = await this.getMenuData();
            if (!_.get(res, 'error')) {
                const condimentResult = res
                const { bestId } = await this.getMenuItem()
                this.setState({
                    menuData: condimentResult,
                    lastId: bestId
                })

            }
            return true
        }
        else {
            let message = i18n.t('global_text_operate_failure');
            const code = _.get(result, 'result.code', '' as 'ER_DUP_ENTRY');
            if (code === 'ER_DUP_ENTRY') {
                message = i18n.t('sale_personal_tool_page_ID_repeat')
            }
            GlobalNotification.error(message)
            return false
        }
    }


    /**
     * 获取全部菜品
     */
    public async getMenuItem() {
        // 获取全部菜单
        const result = await apiManage_rbp.get_menu_item_id_v3();
        if (!_.get(result, 'error')) {
            const allIds = result.map((item) => item.item_id || 0)
            const bestId = firstMissingPositive(allIds)
            return { bestId }
        }
        return { bestId: 1 }
    }


    // *********************
    // View
    // *********************

    render() {
        const { lastId, unitList, isLoading, menuData, activeMenuIndex, deleteOpen, taxGroup, familyGroupList, majorGroupList } = this.state;
        const activeMenu: Condiments | undefined = activeMenuIndex ? _.get(menuData, activeMenuIndex) : undefined
        // 左侧菜单
        const menu = menuData.map((item) => ({
            key: `${item.scomdiment_groups_id}`,
            title: item.comdiment_groups_name ?? '',
            dataSource: item,
        }))
        return (
            <Box hidden={isLoading}>
                <Grid container spacing={6}>
                    <Grid item>
                        {/* 菜单列表 */}
                        <MenuListComponent
                            isHideSort
                            activeMenu={activeMenu ? `${activeMenu?.scomdiment_groups_id}` : undefined}
                            menu={menu}
                            handleClick={(menuData, index) => { this.handleClick(menuData, index) }}
                            handleMenuClick={(key, menu) => {
                                this.handleMenuClick(key, menu)
                            }}
                        />

                    </Grid>
                    <Grid item xs>
                        {/* <div className='FCE menu-excel-btn'>
                            <UploadComponent
                                title={i18n.t('condiment_page_batch_import_condiment')}
                                sheet={['Condiments', 'Condiment_Groups']}
                                onConfirm={this.handleUpload}
                            />
                            <ButtonComponent
                                onClick={() => { this.handleExport() }}
                            >
                                {i18n.t('google_text_export')}
                            </ButtonComponent>
                        </div> */}
                        {
                            activeMenu &&
                            <CondimentGroupDetail
                                familyGroupList={familyGroupList}
                                majorGroupList={majorGroupList}
                                unitList={unitList}
                                taxGroup={taxGroup}
                                detail={activeMenu || {}}
                                lastId={lastId}
                                updateMenuData={async (id?: number) => await this.updateMenuData(id)}
                            />
                        }
                    </Grid>
                </Grid>
                {
                    <DialogComponent
                        open={this.state.isShowCreateGroupDialog}
                        defaultHeaderProps={{
                            title: i18n.t('global_text_name'),
                            onClose: () => {
                                this.setState({
                                    isShowCreateGroupDialog: false
                                })
                            }
                        }}
                        fullWidth={true}
                        maxWidth={'xs'}
                        footer={
                            <div>
                                <Button
                                    color='primary'
                                    variant='outlined'
                                    onClick={() => {
                                        this.setState({
                                            isShowCreateGroupDialog: false
                                        })
                                    }}
                                >{i18n.t('google_text_public_button_cancel')}</Button>
                                <Box marginLeft={4} display='inline-block'>
                                    <ButtonComponent
                                        variant='contained'
                                        handleClick={async () => {
                                            await this.handleAddMenu()
                                        }}
                                    >
                                        {i18n.t('google_text_confirm')}
                                    </ButtonComponent>
                                </Box>
                            </div>}
                    >
                        <CommonInput
                            label={i18n.t('global_text_name')}
                            required={true}
                            regularType={'required'}
                            variant={'outlined'}
                            fullWidth
                            value={this.state.groupName as any}
                            onChange={(event: any) => {
                                const value = event.currentTarget.value
                                this.setState({
                                    groupName: value,
                                })
                            }}
                        />
                    </DialogComponent>
                }
                {
                    deleteOpen &&
                    <DeleteDialogComponent
                        {...{
                            title: i18n.t('condiment_page_delete_dish_group'),
                            open: true,
                            onCancel: () => {
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                            onConfirm: async () => {
                                await this.deleteMenu()
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                        }}
                    />
                }
            </Box>
        )
    }
}

export default CondimentGroupComponent;

// *********************
// Type
// *********************
type Props = {}
type State = {
    // 菜单数据
    menuData: Condiments[];
    // 当前选中菜单的索引
    activeMenuIndex?: string;
    // 删除二次确认弹窗
    deleteOpen: boolean;
    // 右键选中的二级菜单
    activeContextMenu?: Condiments;
    // 税率组列表
    taxGroup: { label: string; value: number; }[];
    // 加载中 初次加载时候使用
    isLoading: boolean;
    // 当前id最大的调味品
    lastId: number;
    // 自定义报表主类别
    majorGroupList: { label: string; value: number; }[];
    // 自定义报表子类别
    familyGroupList: { label: string; value: number; }[];
    // 规格设置
    unitList: { label: string; value: string; }[];
    // 创建调味品组弹窗
    isShowCreateGroupDialog: boolean;
    // 创建调味品组名称
    groupName: string;
}